import { compose } from 'ramda'
import React, { Component } from 'react'
import { DropTarget } from 'react-dnd'

import { withTheme } from 'modules/util'

import dropContainerTheme from './theme.scss'

export class DropContainer extends Component {
  render() {
    const { connectDropTarget, theme, children } = this.props

    return connectDropTarget(
      <div
          className={theme.dropContainer}
          ref={node => {
            this.imageContentNode = node
          }}>
        {children}
      </div>
    )
  }
}

const dropSpec = {
  drop(props, monitor, component) {
    const { imageContentNode } = component

    return {
      itemId: monitor.getItem().id,
      delta: monitor.getDifferenceFromInitialOffset(),
      containerSize: {
        height: imageContentNode.clientHeight,
        width: imageContentNode.clientWidth
      }
    }
  }
}

const collect = connect => ({ connectDropTarget: connect.dropTarget() })

export default compose(
  withTheme(dropContainerTheme),
  DropTarget('Evidence', dropSpec, collect)
)(DropContainer)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/DropContainer/index.js